import React from 'react';
import { Link } from 'react-router';

const IconButtonLink = ({ path, icon, label }) => (
  <Link to={path}>
    <i className={`icon-${icon}`} />
    {label}
  </Link>
);

const IconButton = ({ onClick, icon, label }) => (
  <span className="fake-link" onClick={onClick}>
    <i className={`icon-${icon}`} />
    {label}
  </span>
);

IconButtonLink.displayName = 'IconButtonLink';

export { IconButton };
export default IconButtonLink;
